import { Controller } from "stimulus"

class PageTabController extends Controller {
  static targets = [
    'tab'
  ]

  initialize() {
    this.pageTabSetIndex = parseInt(this.element.getAttribute('data-page-tab-set-index'));
  }

  connect() {
    EventManager.on('page-tab-switch', ({index}) => {
      this.tabTargets.forEach(tab => {
        tab.classList.remove('t-border-b-2', 't-border-white')
      })
      this.tabTargets[parseInt(index)].classList.add('t-border-b-2', 't-border-white')
      if (parseInt(index) == this.pageTabSetIndex) {
        let currentNode = this.element.parentNode;
        currentNode.classList.remove('t-hidden');
        currentNode = currentNode.nextElementSibling;
        while (currentNode != null && !(currentNode.getAttribute('data-collection-key') && currentNode.getAttribute('data-collection-key').includes('CollectionFunds'))) {
          currentNode.classList.remove('t-hidden');
          currentNode = currentNode.nextElementSibling;
        }
      } else {
        let currentNode = this.element.parentNode;
        currentNode.classList.add('t-hidden');
        currentNode = currentNode.nextElementSibling;
        while (currentNode != null && !(currentNode.getAttribute('data-collection-key') && currentNode.getAttribute('data-collection-key').includes('CollectionFunds'))) {
          currentNode.classList.add('t-hidden');
          currentNode = currentNode.nextElementSibling;
        }
      }
    })
    EventManager.emit('page-tab-switch', {
      index: '0'
    })
  }

  switchTab(e) {
    e.preventDefault();
    const button = e.target.closest('button');
    const index = button.getAttribute('data-page-tab-index');
    EventManager.emit('page-tab-switch', {
      index
    })
  }
}

export default PageTabController;
